export enum CoaxClass {
  THIN = 'thin',
  THICK = 'thick',
}
